import { LoginForm } from "@/components/features/LoginForm";
console.log("Hello from Login");
export default function Page() {
  return (
    <div className="flex min-h-[95vh] w-full items-center justify-center">
      <div className="w-full max-w-sm">
        <LoginForm />
      </div>
    </div>
  );
}
